import { AxiosInstance } from 'axios'
import { GlobalState } from './types'
import { Store, useStore } from 'vuex'

export function focusElementWithError(): void {
  setTimeout(() => {
    const parent = document.getElementsByClassName('has-error form-group')
    if (parent.length > 0) {
      let el = parent[0].getElementsByClassName('form-select')
      if (el.length === 0) el = parent[0].getElementsByClassName('form-input')
      if (el.length === 0) el = parent[0].getElementsByClassName('form-radio')
      if (el.length === 0) el = parent[0].getElementsByClassName('form-checkbox')
      if (el.length > 0) (el[0] as any).focus()
    }
  }, 10)
}

/* eslint-disable no-var, prefer-rest-params, @typescript-eslint/no-this-alias */
export function debounce(fn: any, delay: number) {
  let timeoutID: number | any = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}

export function objectResolve(path: string, obj: any) {
  return path.split('.').reduce((prev, curr) => {
    return prev ? prev[curr] : undefined
  }, obj || self)
}

export function downloadStream(data: any, fileName: string) {
  const b = new Blob([data], { type: 'application/octet-stream' })
  const link = document.createElement('a')
  document.body.appendChild(link)
  link.href = window.URL.createObjectURL(b)
  link.download = fileName
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(link.href)
  }, 100)
}

export function useAppViewedList() {
  const store = useStore()

  const recordExists = (key: string) => {
    const i = store.state.appViewedList.indexOf(key)
    return i >= 0
  }

  const setRecord = (value: string) => {
    const lst = store.state.appViewedList
    if (lst.indexOf(value) === -1) {
      lst.push(value)
      store.commit('setAppViewedList', lst)
    }
  }

  return { recordExists, setRecord }
}
